/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowcaseSubmitBody
 */
export interface ShowcaseSubmitBody {
    /**
     * URL for IMAGE/VIDEO or text body for TEXT submissions
     * @type {string}
     * @memberof ShowcaseSubmitBody
     */
    content: string;
}

/**
 * Check if a given object implements the ShowcaseSubmitBody interface.
 */
export function instanceOfShowcaseSubmitBody(value: object): value is ShowcaseSubmitBody {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ShowcaseSubmitBodyFromJSON(json: any): ShowcaseSubmitBody {
    return ShowcaseSubmitBodyFromJSONTyped(json, false);
}

export function ShowcaseSubmitBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowcaseSubmitBody {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function ShowcaseSubmitBodyToJSON(json: any): ShowcaseSubmitBody {
    return ShowcaseSubmitBodyToJSONTyped(json, false);
}

export function ShowcaseSubmitBodyToJSONTyped(value?: ShowcaseSubmitBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

